export const transformResponseRequestSmartTracking = smartTracking => {
  return {
    smart_tracking_requested: smartTracking.smart_tracking_requested,
  }
}
